/**
 * Settings PUT replaces the whole record. User-settings saves must keep
 * the server's openTabs/activeTabId so a stale in-memory snapshot cannot
 * wipe the tab bar (view mode, mission, open doc).
 */
export function mergeSettingsPreservingTabs(current = {}, next = {}) {
  const { openTabs: _ignoredTabs, activeTabId: _ignoredActive, ...nextWithoutTabs } = next;
  return {
    ...current,
    ...nextWithoutTabs,
    openTabs: current.openTabs,
    activeTabId: current.activeTabId,
  };
}
